import hotImg from '../assets/hot.png';
import { List, Row, Col } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import unit from '../unit';

// 个股热搜榜
const HotPersonageSideber = (props) => {
    const navigate = useNavigate();
    const [name, setName] = useState('股东');
    const [hotSource, setHotSource] = useState([]);

    const getSourceList = () => {
        const path = '/event/index/hotsearch';
        unit.httpGet(path, { "tab": 0 }, (data) => {
            setName(data.name);
            if (data.list.length > 0) {
                let _hotSource = data.list.map((item, index) => ({
                    index,
                    name: item.name,
                    code: item.code
                }));
                setHotSource(_hotSource);
            }
        });
    };

    useEffect(() => {
        const tab = props.tab;
        getSourceList(tab);
    }, [props.tab]); 

    return (
        <div className='content-block'>
            <div className='block-title' style={{ background: "linear-gradient(180deg, #FFE6E6 0%, #FFFFFF 100%)" }}>
                <img className='title-icon' src={hotImg} alt="" /> 
                <span style={{ verticalAlign: 'middle', marginLeft: '6px' }}>{name}个股热搜榜</span>
            </div>
            <Row gutter={16}> 
                <Col span={12}>
                    <List
                        itemLayout="horizontal"
                        size="small"
                        split={false}
                        locale={{emptyText: "暂无数据" }} 
                        dataSource={hotSource.filter((_, index) => index % 2 === 0)} 
                        renderItem={(item) => (
                            <List.Item onClick={() => navigate(`/particulars/${item.code}`)}>
                                <div>
                                    <span className={unit.getTextClassName(item.index)}>{item.index + 1}</span>
                                    {item.name}
                                </div>
                            </List.Item>
                        )}
                    />
                </Col>
                <Col span={12}>
                    <List
                        itemLayout="horizontal"
                        size="small"
                        split={false}
                        locale={{emptyText: "暂无数据" }} 
                        dataSource={hotSource.filter((_, index) => index % 2 !== 0)}
                        renderItem={(item) => (
                            <List.Item onClick={() => navigate(`/particulars/${item.code}`)}>
                                <div>
                                    <span className={unit.getTextClassName(item.index)}>{item.index + 1}</span>
                                    {item.name}
                                </div>
                            </List.Item>
                        )}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default HotPersonageSideber;